import tenants from "@/http/requests/tenants"

export default {
    async getAllTenants({commit}, data) {
        try {
            let response = await tenants.getAllTenants(data.token, data.filterUsers ? data.filterUsers : false);
            commit('setTenants', {tenants: response});
        } catch(Exception) {
            console.log(Exception)
            commit('setTenants', {tenants: []});
        }
    },
    async fetchPaginatedTenants({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.fetchPaginatedTenants(data.token, data.filterUsers, data.page, data.limit, data.search, data.sortName, data.sortType, data.strictFqdn).then(
                response => {
                    commit('SET_PAGINATED_TENANTS', response.data);
                    resolve(response.data);
                }
            ).catch(exception => reject(exception));
        });
    },
    addTenant(context, object) {
        try {
            return new Promise((resolve, reject) => {
                tenants.addTenant(object.token, object.name, object.cnpj, object.features, object.template, object.pool, object.userLimit, object.partnerId, object.plan, object.ticketLimit)
                .then((response) => {
                    resolve(response);
                })
                .catch((exception) => {
                    reject(exception);
                });
            });
            
        } catch(Exception) {
            console.log(Exception);
            throw Exception;
        }
    },
    async setCurrentTenant({commit}, {tenant}) {
        commit('setCurrentTenant', {tenant: tenant});
    },
    deleteTenant(_, data) {
        return new Promise((resolve, reject) => {
            tenants.deleteTenant(data, data && data.token ? data.token : null).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getOrders(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getOrders(data.startAt, data.finishAt, data.byDay, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getConsolidatedOrders(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getConsolidatedOrders(data, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getAttendances(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getAttendances(data.startAt, data.finishAt, data.websiteId, data.estimation, data.token, data.attendance).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    sendAttendancesToMail(_, data) {
        return new Promise((resolve, reject) => {
            tenants.sendAttendancesToMail(data.startAt, data.finishAt, data.websiteId, data.estimation, data.email, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    countPerPool({commit}, data) {
        return new Promise((resolve, reject) => {
            tenants.countPerPool(data.filterByEnvironment, data.token).then(response => {
                commit('SET_COUNT_PER_POOL', response.data);
                resolve(response);
            }).catch(exception => reject(exception));
        });
    },
    getInstanceLogs(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getInstanceLogs(data.startAt, data.finishAt, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getReasons(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getReasons(data.token, data.startAt, data.finishAt, data.tenancyId, data.reasonId).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    restoreTenant(_, data) {
        return new Promise((resolve, reject) => {
            tenants.restoreTenant(data.id, data.token, data.reason).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    updateTenantPlan(_, data) {
        return new Promise((resolve, reject) => {
            tenants.updateTenantPlan(data.token, data.id, data.plan, data.user, data.ticket, data.tenantName, data.keepUserIds).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    updatePlanExpiration(_, data) {
        return new Promise((resolve, reject) => {
            tenants.updatePlanExpiration(data.token, data.id, data.planExpirationDate, data.supportLink).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    resetExpirationPopup(_, data) {
        return new Promise((resolve, reject) => {
            tenants.resetExpirationPopup(data.token, data.id).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getTenantUsers(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getTenantUsers(data.token, data.tenantName).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getFeatures(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getFeatures(data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    syncAnalytics(_, data) {
        return new Promise((resolve, reject) => {
            tenants.syncAnalytics(
                data.fromDate,
                data.toDate,
                data.forceUpdate,
                data.tenantName,
                data.token
            ).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    updateFeatures(_, data) {
        return new Promise((resolve, reject) => {
            tenants.updateFeatures(data.features, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateCampaignStatusWebhook(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateCampaignStatusWebhook(data.startAt, data.finishAt, data.type, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateAttendanceProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateAttendanceProductivityReport(data.fromDate, data.toDate, data.selectedUsers, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateCampaignProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateCampaignProductivityReport(data.fromDate, data.toDate, data.type, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateOperatorProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateOperatorProductivityReport(data.fromDate, data.toDate, data.selectedUsers, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateOrderProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateOrderProductivityReport(data.fromDate, data.toDate, data.email, data.tenantName, data.token, data.seeDetails).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateLoginFailuresProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateLoginFailuresProductivityReport(data.fromDate, data.toDate, data.selectedUsers, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateGradeProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateGradeProductivityReport(data.fromDate, data.toDate, data.selectedUsers, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    generateMariaProductivityReport(_, data) {
        return new Promise((resolve, reject) => {
            tenants.generateMariaProductivityReport(data.fromDate, data.toDate, data.selectedUsers, data.email, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getDistributionStatus(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getDistributionStatus(data.startAt, data.finishAt, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    diagnoseInstance(_, data) {
        return new Promise((resolve, reject) => {
            tenants.diagnoseInstance(data.instanceId, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getCampaigns(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getCampaigns(data.type, data.page, data.limit, data.searchQuery, data.orderQuery, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    restartCampaign(_, data) {
        return new Promise((resolve, reject) => {
            tenants.restartCampaign(data.campaignId, data.minutes, data.messages, data.startAt, data.finishAt, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getTenantChatFlowTemplate(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getTenantChatFlowTemplate(data.tenantName, data.flowType, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    replicateTenantChatFlow(_, data) {
        return new Promise((resolve, reject) => {
            tenants.replicateTenantChatFlow(
              data.sourceTenant,
              data.targetTenants,
              data.sourceTenantDetails,
              data.targetTenantDetails,
              data.flowType,
              data.includeSchedule,
              data.authorizationPassword,
              data.clientIp,
              data.token,
              data.timeout
            ).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getTenantChatFlowReplicationLogs(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getTenantChatFlowReplicationLogs(
              data.flowType,
              data.page,
              data.limit,
              data.token
            ).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getTenantChatFlowReplicationLogById(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getTenantChatFlowReplicationLogById(data.logId, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getFinishedTicketsRank(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getFinishedTicketsRank(data.from, data.to, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    undoFinishedTickets(_, data) {
        return new Promise((resolve, reject) => {
            tenants.undoFinishedTickets(data.userId, data.from, data.to, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getInstances(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getInstances(data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    campaignMassDryRun(_, data) {
        return new Promise((resolve, reject) => {
            tenants.campaignMassDryRun(data.payload, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    campaignMassOptions(_, data) {
        return new Promise((resolve, reject) => {
            tenants.campaignMassOptions(data.tenantName, data.token, data.instanceId).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    campaignMassExecute(_, data) {
        return new Promise((resolve, reject) => {
            tenants.campaignMassExecute(data.batchId, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    campaignMassHistory(_, data) {
        return new Promise((resolve, reject) => {
            tenants.campaignMassHistory(
                data.page,
                data.limit,
                data.status,
                data.requestedBy,
                data.tenantId,
                data.from,
                data.to,
                data.token
            ).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    campaignMassHistoryDetail(_, data) {
        return new Promise((resolve, reject) => {
            tenants.campaignMassHistoryDetail(data.batchId, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    campaignMassRetryFailed(_, data) {
        return new Promise((resolve, reject) => {
            tenants.campaignMassRetryFailed(data.batchId, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    customerCategoryMassUpload(_, data) {
        return new Promise((resolve, reject) => {
            tenants.customerCategoryMassUpload(data.tenantName, data.file, data.sheetsMetadata, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    customerCategoryMassDryRun(_, data) {
        return new Promise((resolve, reject) => {
            tenants.customerCategoryMassDryRun(data.payload, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    customerCategoryMassExecute(_, data) {
        return new Promise((resolve, reject) => {
            tenants.customerCategoryMassExecute(data.batchId, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    customerCategoryMassHistory(_, data) {
        return new Promise((resolve, reject) => {
            tenants.customerCategoryMassHistory(
                data.page,
                data.limit,
                data.status,
                data.requestedBy,
                data.tenantId,
                data.from,
                data.to,
                data.token
            ).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    customerCategoryMassHistoryDetail(_, data) {
        return new Promise((resolve, reject) => {
            tenants.customerCategoryMassHistoryDetail(data.batchId, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    customerCategoryMassRetryFailed(_, data) {
        return new Promise((resolve, reject) => {
            tenants.customerCategoryMassRetryFailed(data.batchId, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    getPartners(_, data) {
        return new Promise((resolve, reject) => {
            tenants.getPartners(data.token, data.tenantName).then(response => resolve(response)).catch(exception => reject(exception));
        });
    },
    updatePartner(_, data) {
        return new Promise((resolve, reject) => {
            tenants.updatePartner(data.partnerId, data.tenantName, data.token).then(response => resolve(response)).catch(exception => reject(exception));
        });
    }
}